import * as api from 'App/api/categories'
import * as positioningActions from '../positioning'
import * as itemsActions from 'App/modules/items/items'
import update from 'immutability-helper'
import omit from 'lodash/omit'
import map from 'lodash/map'
import merge from 'lodash/merge'
import pick from 'lodash/pick'

export const ADD_ITEM_TO_CATEGORY = 'categories/ADD_ITEM_TO_CATEGORY'
export const UN_ASSIGN_ITEM_FROM_CATEGORY = 'categories/UN_ASSIGN_ITEM_FROM_CATEGORY'
export const REMOVE_CATEGORY = 'categories/REMOVE_CATEGORY'
export const REMOVE_SUBCATEGORY = 'categories/REMOVE_SUBCATEGORY'
export const FETCH_CATEGORIES_SUCCESS = 'categories/FETCH_CATEGORIES_SUCCESS'
export const CREATE_CATEGORY_SUCCESS = 'categories/CREATE_CATEGORY_SUCCESS'
export const UPDATE_CATEGORY_SUCCESS = 'categories/UPDATE_CATEGORY_SUCCESS'
export const CREATE_SUBCATEGORY_SUCCESS = 'categories/CREATE_SUBCATEGORY_SUCCESS'

export const CATEGORIES_TYPES = {
  allItems: 0,
  category: 1,
  parentCategory: 2,
  subcategory: 3,
  linkCategory: 4,
  linkSubcategory: 5
}

export function fetchCategories(boardId) {
  return function(dispatch) {
    return api.fetchCategories(boardId)
      .then(response => {
        dispatch({
          type: FETCH_CATEGORIES_SUCCESS,
          boardId,
          categories: response.data,
          categoriesIds: response.categories_ids
        })

        return response
      })
  }
}

export function createCategory(boardId, params) {
  return function (dispatch) {
    return api.createCategory(boardId, params)
      .then(category => {
        dispatch({
          type: CREATE_CATEGORY_SUCCESS,
          boardId,
          category,
          categoryId: category.id,
          trackingParams: {
            category_id: category.id,
            category_name: category.name,
            category_type: category.category_type,
            url: category.url
          }
        })
      })
  }
}

export function updateCategory(params) {
  return function (dispatch) {
    return api.updateCategory(params)
      .then(category => {
        dispatch({
          type: UPDATE_CATEGORY_SUCCESS,
          category,
          trackingParams: {
            category_id: category.id,
            category_name: category.name,
            category_type: category.category_type,
            url: category.url
          }
        })
      })
  }
}

export function removeCategory(boardId, category) {
  return function (dispatch) {
    dispatch({
      type: REMOVE_CATEGORY,
      boardId,
      category,
      trackingParams: {
        category_id: category.id,
        category_type: category.category_type,
        category_name: category.name
      }
    })

    return api.removeCategory(category.id)
      .catch(() => fetchCategories(boardId, dispatch))
  }
}

export function createSubcategory(boardId, params) {
  return function (dispatch) {
    return api.createSubcategory(boardId, params)
      .then(subcategory => {
        dispatch({
          type: CREATE_SUBCATEGORY_SUCCESS,
          boardId,
          subcategory,
          parentCategoryId: params.parentCategoryId,
          trackingParams: {
            category_id: subcategory.id,
            category_type: subcategory.category_type,
            category_name: subcategory.name,
            parent_category_id: subcategory.parent_category_id
          }
        })
      })
  }
}

export function removeSubcategory(subcategory) {
  return function (dispatch) {
    dispatch({
      type: REMOVE_SUBCATEGORY,
      subcategory,
      boardId: subcategory.board_id,
      parentCategoryId: subcategory.parent_category_id,
      trackingParams: {
        category_id: subcategory.id,
        category_type: subcategory.category_type,
        category_name: subcategory.name,
        parent_category_id: subcategory.parent_category_id
      }
    })
    return api.removeSubcategory(subcategory.id)
      .catch(() => fetchCategories(subcategory.board_id))
  }
}

export function addItemToCategory(boardId, categoryId, itemId) {
  return function (dispatch) {
    dispatch({
      type: ADD_ITEM_TO_CATEGORY,
      boardId,
      categoryId,
      itemId
    })
    return api.addItem({ categoryId, itemId })
      .catch(() => fetchCategories(boardId))
  }
}

export function unAssignItemFromCategory(boardId, categoryId, itemId) {
  return function (dispatch) {
    dispatch({
      type: UN_ASSIGN_ITEM_FROM_CATEGORY,
      boardId,
      categoryId,
      itemId
    })
    return api.removeCategoryItem({ categoryId, itemId })
      .catch(() => fetchCategories(boardId))
  }
}

export function changeCategoryPosition({
  droppedCategory,
  targetId,
  dropDirection,
  categories,
  categoriesIds
}) {
  return dispatch => {
    return positioningActions.changeCategoryPosition({
      droppedCategory,
      targetId,
      dropDirection,
      categories,
      categoriesIds
    })(dispatch)
  }
}

const initialState = {
  data: {
    // [categoryId]: {
    //   name:,
    //   category_type:,
    //   parent_category_id:,
    //   board_id:,
    //   url:
    //   items_count:,
    //   subcategories_ids:[]
    //   item_ids:[],
    //   description:
    // }

  },
  isFetching: false
}

export function prepareInitialState() {
  return initialState
}

function category(state, action) {
  /* eslint-disable no-case-declarations */
  switch (action.type) {
    case ADD_ITEM_TO_CATEGORY:
    case itemsActions.CREATE_ITEM_SUCCESS:
    case itemsActions.CREATE_FILE_ITEM_SUCCESS:
    case itemsActions.IMPORT_CONTENT_ITEM_SUCCESS:
      const itemId = action.itemId || action.item.id
      return {
        ...state,
        item_ids: [...state.item_ids, itemId],
        items_count: state.items_count + 1
      }
    case UN_ASSIGN_ITEM_FROM_CATEGORY:
    case itemsActions.DELETE_ITEM: {
      const itemId = action.itemId || action.item.id
      const index = state.item_ids.indexOf(itemId)
      return {
        ...state,
        item_ids: update(state.item_ids, { $splice: [[index, 1]] }),
        items_count: state.items_count - 1
      }
    }
    case positioningActions.CHANGE_CATEGORY_POSITION:
    case positioningActions.CHANGE_SUBCATEGORY_POSITION:
      return {
        ...state,
        position: action.position
      }
    case itemsActions.UPDATE_ITEM_SUCCESS: {
      const { item, previousItem } = action
      if (item.categories_ids.includes(state.id) && previousItem.categories_ids.includes(state.id)) {
        // item update didn't affect this category
        return state
      } else if (item.categories_ids.includes(state.id)) {
        // item assigned to this category after update
        return {
          ...state,
          item_ids: [...state.item_ids, action.item.id],
          items_count: state.items_count + 1
        }
      } else {
        // item unassigned from this category
        const index = state.item_ids.indexOf(action.item.id)
        return {
          ...state,
          item_ids: update(state.item_ids, { $splice: [[index, 1]] }),
          items_count: state.items_count - 1
        }
      }
    }
    default:
      return state
  }
}

export default function categories(state = initialState, action) {
  switch (action.type) {
    case FETCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.categories
        }
      }
    case positioningActions.CHANGE_CATEGORY_POSITION:
      return {
        ...state,
        data: {
          ...state.data,
          [action.category.id]: category(state.data[action.category.id], action)
        }
      }
    case CREATE_CATEGORY_SUCCESS:
    case UPDATE_CATEGORY_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          [action.category.id]: action.category
        }
      }
    case positioningActions.CHANGE_SUBCATEGORY_POSITION:
      return {
        ...state,
        data: {
          ...state.data,
          [action.category.id]: category(state.data[action.category.id], action),
          // change the order of the subcategories after position change
          [action.category.parent_category_id]: {
            ...state.data[action.category.parent_category_id],
            // new order subcategories
            subcategories_ids: action.categoriesIds
          }
        }
      }
    case positioningActions.CHANGE_CATEGORY_POSITION_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          [action.category.id]: action.category
        }
      }
    case ADD_ITEM_TO_CATEGORY:
    case UN_ASSIGN_ITEM_FROM_CATEGORY:
      return {
        ...state,
        data: {
          ...state.data,
          [action.categoryId]: category(state.data[action.categoryId], action)
        }
      }
    case CREATE_SUBCATEGORY_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          [action.subcategory.id]: action.subcategory,
          [action.parentCategoryId]: {
            ...state.data[action.parentCategoryId],
            category_type: CATEGORIES_TYPES.parentCategory,
            items_count: 0,
            subcategories_ids: update(state.data[action.parentCategoryId].subcategories_ids, { $push: [action.subcategory.id] })
          }
        }
      }
    case REMOVE_CATEGORY:
      return {
        ...state,
        data: {
          ...omit(state.data, action.category.id)
        }
      }
    case REMOVE_SUBCATEGORY: {
      const parentCategory = state.data[action.parentCategoryId]
      const index = parentCategory.subcategories_ids.indexOf(action.subcategory.id)
      let type = parentCategory.category_type
      if (parentCategory.subcategories_ids.length === 1) {
        type = CATEGORIES_TYPES.category
      }
      return {
        ...state,
        data: {
          ...omit(state.data, action.subcategory.id),
          [action.parentCategoryId]: {
            ...state.data[action.parentCategoryId],
            category_type: type,
            subcategories_ids: update(state.data[action.parentCategoryId].subcategories_ids, { $splice: [[index, 1]] })
          }

        }
      }
    }
    case itemsActions.CREATE_ITEM_SUCCESS:
    case itemsActions.DELETE_ITEM:
    case itemsActions.CREATE_FILE_ITEM_SUCCESS:
    case itemsActions.IMPORT_CONTENT_ITEM_SUCCESS: {
      const prevCategoriesState = pick(state.data, action.item.categories_ids)
      // build new state
      let newCategoriesState = {}

      newCategoriesState = map(prevCategoriesState, (categoryState) => {
        return category(categoryState, action)
      })
        .reduce((newCategoriesState, newCategoryState) => {
          return merge(newCategoriesState, { [newCategoryState.id]: newCategoryState })
        }, {})

      return {
        ...state,
        data: {
          ...state.data,
          ...newCategoriesState
        }
      }
    }
    case itemsActions.UPDATE_ITEM_SUCCESS: {
      const prevCategoriesState = pick(
        state.data,
        [...action.item.categories_ids, ...action.previousItem.categories_ids]
      )
      // build new state
      let newCategoriesState = {}

      newCategoriesState = map(prevCategoriesState, (categoryState) => {
        return category(categoryState, action)
      })
        .reduce((newCategoriesState, newCategoryState) => {
          return merge(newCategoriesState, { [newCategoryState.id]: newCategoryState })
        }, {})

      return {
        ...state,
        data: {
          ...state.data,
          ...newCategoriesState
        }
      }
    }

    default:
      return {
        ...state
      }
  }
}
